// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { SyntheticEvent, useEffect, useState } from 'react';
import IconButton from '../IconButton';
import Image from '../Image';
import Link from '../Link';
import Icon from '../Icon';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import styled from '@emotion/styled';
import {
  fontWeight,
  borderRadius,
  mediaMax,
  spacing,
  fontSize,
} from 'presentations/views/styles';
import {
  black,
  gray04,
  primary,
  white,
  whiteFix,
} from 'presentations/views/styles/color';
import Grow from '@mui/material/Grow';
import { setEvent } from 'presentations/views/helpers/analytics';

interface Props {}
export default function Component(props: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [installPromptEvent, setInstallPromptEvent] = useState<any>(null);

  const beforeinstallprompt = (e: any) => {
    e.preventDefault();
    setInstallPromptEvent(e);
    setIsOpen(true);
    setEvent('pwa app install show');
    return false;
  };

  const isAndroid = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf('android') > 0 && userAgent.indexOf('chrome') > 0;
  };

  useEffect(() => {
    if (isAndroid()) {
      window.addEventListener('beforeinstallprompt', beforeinstallprompt);
      return function cleanUp() {
        window.removeEventListener('beforeinstallprompt', beforeinstallprompt);
      };
    }
  }, []);

  const onClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    setIsOpen(false);
  };

  const onClickClose = (e: SyntheticEvent) => {
    e.stopPropagation();
    setIsOpen(false);
  };
  const onClickInstall = (e: SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (!installPromptEvent) return;
    installPromptEvent.prompt();
    installPromptEvent.userChoice
      .then((choiceResult: any) => {
        setIsOpen(false);
        setInstallPromptEvent(null);
        if (choiceResult.outcome === 'accepted') {
          setEvent('pwa app installed');
        } else {
          setEvent('pwa app dismiss install');
        }
      })
      .catch(() => {
        setIsOpen(false);
        setInstallPromptEvent(null);
        setEvent('pwa app install error');
      });
  };
  const t = translateInComponent(translations);

  return (
    <StyledSnackbar
      open={isOpen}
      autoHideDuration={null}
      TransitionComponent={Grow}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Container>
        <StyledSnackbarContent
          message={
            <BannerContainer onClick={onClickInstall}>
              <IconButton onClick={onClickClose}>
                <CloseIcon name="close" />
              </IconButton>
              <AppIconContainer>
                <Image
                  src="logo/symbol.svg"
                  alt={'Jicoo'}
                  width={32}
                  height={32}
                />
              </AppIconContainer>
              <Description>{t('add home')}</Description>
              <Install>{t('install')}</Install>
            </BannerContainer>
          }
        />
      </Container>
    </StyledSnackbar>
  );
}

const StyledSnackbar = styled(Snackbar)`
  ${mediaMax.smartphone} {
    left: 0;
    right: 0;
    bottom: 80px;
    transform: none;
  }
`;
const StyledSnackbarContent = styled(SnackbarContent)`
  background-color: ${white};
  font-weight: ${fontWeight('bold')};
  border: 1px solid ${primary};
  border-radius: ${borderRadius(6)};
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.05);
  padding: 0;
`;
const CloseIcon = styled(Icon)`
  color: ${primary};
`;

const Container = styled.div`
  min-width: 600px;
  ${mediaMax.smartphone} {
    min-width: 80%;
    padding: 0 ${spacing(16)};
  }
  .MuiSnackbarContent-message {
    width: 100%;
  }
`;

const BannerContainer = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const AppIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${gray04};
  border-radius: ${borderRadius(6)};
  padding: ${spacing(6)};
`;
const Description = styled.div`
  /* font-size: ${fontSize(12)}; */
  margin-left: ${spacing(16)};
  color: ${black};
  flex: 1;
`;
const Install = styled.div`
  color: ${whiteFix};
  background-color: ${primary};
  margin-left: ${spacing(16)};
  margin-right: ${spacing(16)};
  padding: ${spacing(4)} ${spacing(16)};
  border-radius: ${borderRadius(6)};
  ${mediaMax.smartphone} {
    font-size: ${fontSize(12)};
    padding: ${spacing(4)} ${spacing(8)};
  }
`;
